import { Pipe, PipeTransform } from '@angular/core';
import { Row } from '@vendasta/galaxy/table';
import { ObjectType, SingleRowAction } from '../tokens-and-interfaces';

type PipeInput = SingleRowAction[] | null | undefined;
type PipeOutput = PipeInput;

interface PipeParams {
  row: Row;
  objectType: ObjectType;
}

@Pipe({
  name: 'filterVisibleActions',
  standalone: true,
})
export class FilterVisibleActionsPipe implements PipeTransform {
  transform(actions: PipeInput, params: PipeParams): PipeOutput {
    return actions?.filter((action) => action?.visible?.(params?.row, params?.objectType) ?? true);
  }
}
